import React from 'react';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { useThemeMode } from '../../theme';
import logoColor from '../../assets/brand/clarivate-logo-horizontal-color.svg';
import logoDark from '../../assets/brand/clarivate-logo-horizontal-dark.svg';
import logoSymbol from '../../assets/brand/clarivate-brand-symbol-color.svg';

interface Props {
  collapsed: boolean;
}

const Root = styled('div', {
  shouldForwardProp: prop => prop !== 'collapsed',
})<{ collapsed: boolean }>(({ theme, collapsed }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: collapsed ? 'center' : 'flex-start',
  height: 56,
  padding: collapsed ? '0' : '0 16px',
  flexShrink: 0,
  borderBottom: `1px solid ${theme.tokens.sidebarBorder}`,
}));

const LogoLink = styled(Link)({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  gap: 8,
  overflow: 'hidden',
});

const LogoFull = styled('img')({
  height: 40,
  width: 'auto',
  objectFit: 'contain',
});

const LogoIcon = styled('img')({
  height: 44,
  width: 44,
  objectFit: 'contain',
});

export default function SidebarHeader({ collapsed }: Props) {
  const { effective } = useThemeMode();
  const logoFull = effective === 'dark' ? logoDark : logoColor;
  return (
    <Root collapsed={collapsed}>
      <LogoLink to="/">
        {collapsed ? (
          <LogoIcon src={logoSymbol} alt="Clarivate" />
        ) : (
          <LogoFull src={logoFull} alt="Clarivate" />
        )}
      </LogoLink>
    </Root>
  );
}
